import PendoIconButton from '../icon-button/pendo-icon-button.vue.js';
import PendoButton from '../button/pendo-button.vue.js';
import PendoMultiselect from '../multiselect/pendo-multiselect.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import isEmpty from 'lodash/isEmpty.js';
import differenceBy from 'lodash/differenceBy.js';

var script = {
  name: 'PendoMultiselectGroup',
  components: {
    PendoIconButton,
    PendoButton,
    PendoMultiselect
  },
  directives: {
    PendoTooltip
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionsLabel: {
      type: String,
      default: null
    },
    addLabel: {
      type: String,
      default: 'Add Option'
    },
    allSelectedLabel: {
      type: String,
      default: 'All available options selected.'
    }
  },
  data() {
    return {
      model: []
    };
  },
  computed: {
    allOptionsSelected() {
      return !this.availableOptions.length || this.model.length === this.options.length;
    },
    availableOptions() {
      return differenceBy(this.options, this.model, this.$attrs.valueKey || 'id');
    },
    disableRemove() {
      return isEmpty(this.model[0]);
    },
    disableAdd() {
      return this.disabled || this.allOptionsSelected || this.model.length === this.options.length;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.model = [...new Set([...this.value])];
      if (!this.model.length) {
        this.add();
      }
    },
    add() {
      if (this.disableAdd) {
        return;
      }
      this.model.push({});
      this.onModelChange();
    },
    remove(index) {
      if (index === 0 && this.model.length === 1) {
        this.model = [{}];
      } else {
        this.model = this.model.slice(0, index).concat(this.model.slice(index + 1));
      }
      this.onModelChange();
    },
    select(option, index) {
      this.$set(this.model, index, option);
      this.onModelChange();
    },
    onModelChange() {
      const model = this.model.filter(option => !isEmpty(option));
      this.$emit('change', model);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect-group.vue2.js.map
